<template>
    <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <Aside></Aside>
        <!--end::Aside-->
        <div class="d-flex flex-column flex-row-fluid wrapper m-4 pt-0" id="kt_wrapper">
            <div class="content d-flex flex-column flex-column-fluid mt-22 mt-lg-0 pb-0" id="kt_content">
                <Toolbar>
                    <div v-if="!isProcessed && canEditUserRequests">
                        <ToolbarLink v-if="Permission.VIEW_ALL_USER_REQUESTS"
                                     :href="$route('user.requests.email.preview', [userRequest.id] )"
                                     target="_new"
                        >
                        <span class="svg-icon svg-icon-md">
                            <i class="fas fa-mail-bulk"></i>
                        </span> Preview Emails
                        </ToolbarLink>
                        <ToolbarLink v-if="Permission.ASSIGN_USER_TO_AGENCY"
                                     :href="$route('user.assign-to-agency', [userRequest.id] )">
                    <span class="svg-icon svg-icon-md">
                        <i class="fas fa-user-secret"></i>
                    </span>
                            {{ __('agency.assign') }}
                        </ToolbarLink>
                        <ToolbarLink :href="$route('user.requests.approve', [userRequest.id])"
                                     class="btn btn-success mr-3"><i class="fas fa-check"></i> {{
                                __('actions.approve')
                            }}
                        </ToolbarLink>
                        <button onclick="reject(userRequest.id)" class="btn btn-danger">
                            <i class="fas fa-times"></i> {{ __('actions.reject') }}
                        </button>
                    </div>
                    <div v-else>
                        <ToolbarLink v-if="Permission.VIEW_ALL_USER_REQUESTS"
                                     :href="$route('user.requests.email.preview', [userRequest.id] )"
                                     target="_new"
                        >
                        <span class="svg-icon svg-icon-md">
                            <i class="fas fa-mail-bulk"></i>
                        </span> Preview Emails
                        </ToolbarLink>
                        <button v-if="isApproved" class="btn btn-light-success mr-3"><i
                            class="fas fa-check"></i> {{ __('user-request.approved') }}
                        </button>

                        <button v-else-if="canEditUserRequests" class="btn btn-light-danger mr-3"><i
                            class="fas fa-times"></i> {{ __('user-request.rejected') }}
                        </button>

                    </div>
                </Toolbar>
                <Card>
                    <div class="d-flex flex-row">
                        <div>
                <span
                    :class="`w-200px font-weight-bolder py-3 mr-4 float-left badge badge-pill text-${ badgeClass } bg-light-${ badgeClass }`">{{
                        badgeText
                    }}</span>
                        </div>
                        <div>
                            <h2>{{ userRequest.request_type_name }}</h2>
                        </div>
                    </div>
                    <hr>
                    <slot/>
                    <div class="mt-5 pt-1">
                        <hr class="my-5">

                        <div v-if="isApproved" class="d-inline-block kt-padding-l-5">({{
                                __('user-request.processed_by')
                            }}:
                            {{ userRequest.agent ? userRequest.agent.name : ' Bearbeitung steht aus' }})
                        </div>
                        <div v-else-if="canEditUserRequests" class="d-inline-block kt-padding-l-10">{{
                                __('user-request.reason')
                            }}
                            : {{ userRequest.reason }}
                        </div>
                    </div>
                </Card>
                <Card class="mt-5" v-if="userRequest.attachments.length > 0 && canEditUserRequests">
                    <div class="card-header">
                        <div class="card-title mb-0">
                            <h3 class="card-label m-0"><i class="fas fa-file mr-2"></i>Anhänge</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th>Upload Name</th>
                                <th>Typ</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="attachment in userRequest.attachments">
                                <td>{{ attachment.original_name }}</td>
                                <td>{{ attachment.type }}</td>
                                <td class="text-right">
                                    <a :href="$route('user.requests.attachment.download', [userRequest.id, attachment.id])"
                                       class="btn btn-xs btn-info">
                                        <i class="fas fa-download mr-1"></i>
                                        Herunterladen
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Card>
            </div>
            <PageFooter/>
        </div>
    </div>
</template>

<script>
import Card from '@components/Cards/Card.vue';
import {PermissionsMixin} from '@js/permissions';
import Toolbar from '@components/Toolbar.vue';
import ToolbarLink from '@components/ToolbarLink.vue';
import BackButton from '@components/BackButton.vue';
import Aside from '@components/Navigation/Aside.vue';
import PageFooter from '@layouts/Includes/PageFooter.vue';

export default {
    components: {PageFooter, Aside, BackButton, ToolbarLink, Toolbar, Card},

    mixins: [PermissionsMixin],

    props: {
        userRequest: Object,
    },

    computed: {
        canEditUserRequests() {
            return this.Permission.EDIT_ARTICLE_UPDATE_REQUEST || this.Permission.EDIT_USER_REQUESTS ||
                this.Permission.EDIT_AGENCY_USER_REQUESTS;
        },
        isProcessed() {
            return this.userRequest.approved !== null;
        },
        isApproved() {
            return this.isProcessed && this.userRequest.approved;
        },
        badgeClass() {
            return this.isProcessed ? (this.isApproved ? 'success' : 'danger') : 'secondary';
        },
        badgeText() {
            return this.isProcessed
                ? (this.isApproved ? __('user-request.approved') : __('user-request.rejected'))
                : __('user-request.pending');
        },
    },

    methods: {
        reject(id) {
            Swal.fire({
                title: 'Bitte geben Sie einen Grund an',
                input: 'text',
                inputLabel: 'Grund',
                inputValue: '',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Sie müssen eine Begründung angeben!';
                    }
                },
            }).then((result) => {
                if (result.value) {
                    this.$inertia.put(this.$route('user-request.reject', {'userRequest': id}), {reason: result.value});
                }
            });
        },
    },
};
</script>
